import React, { useEffect, useState } from "react";
import NavBar from "../../../component/b2c/navBar/navBar";
import Sidebar from "../../../component/b2c/sidebar/sidebar";
import { useMyContext } from "../../../context/MyContext";
import { useNavigate } from "react-router-dom";
import { Base_Url, dashboard, shipmentList } from "../../../config/config";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import ImageOfferSlider from "../../../component/Alloffers/alloffer";

export default function DashBoard() {
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    data: {},
    chartData: { monthlyData: [] },
  });
  const [orders, setOrders] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const token = localStorage.getItem("token");
  const cusid = localStorage.getItem("cus_id");

  const dummy = { data: {}, chartData: { monthlyData: [] } };

  useEffect(() => {
    load();
  }, []);
  const load = async () => {
    setLoadingOrders(true);
    try {
      const r1 = await fetch(Base_Url + dashboard, {
        method: "GET",
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });
      const j1 = await r1.json();
      setStats(j1?.data ? j1 : dummy);
    } catch {
      setStats(dummy);
    }
    try {
      const r2 = await fetch(`${Base_Url}${shipmentList}`, {
        method: "GET",
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });
      const j2 = await r2.json();

      console.log("shipment api response", j2);
      const pendingData = Array.isArray(j2?.data)
        ? j2.data
        : Array.isArray(j2?.rows)
          ? j2.rows
          : Array.isArray(j2)
            ? j2
            : [];
      setAllOrders(pendingData);
      setOrders(
        pendingData.filter((item) =>
          String(item.status || "")
            .toLowerCase()
            .includes("pending")
        )
      );
      const r3 = await fetch(`${Base_Url}${shipmentList}?status=pending`, {
        method: "GET",
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });
      const j3 = await r3.json();
      const pendingOnly = Array.isArray(j3?.data)
        ? j3.data
        : Array.isArray(j3?.rows)
          ? j3.rows
          : [];
      if (pendingOnly.length) {
        setOrders(pendingOnly);
      }
      setLoadingOrders(false);
    } catch {
      setOrders([]);
      setLoadingOrders(false);
    }
  };

  // const cards = [
  //   {
  //     title: "Total Orders",
  //     value: stats?.data?.total_order || orders.length,
  //     bg: "from-emerald-500 to-green-600",
  //   },
  //   {
  //     title: "NDR & RTO",
  //     value: (stats?.data?.total_ndr || 0) + (stats?.data?.total_rto || 0),
  //     bg: "from-teal-500 to-cyan-600",
  //   },
  //   {
  //     title: "COD Remittance",
  //     value: stats?.data?.cod_remittance || "₹0",
  //     bg: "from-amber-500 to-orange-500",
  //   },
  //   {
  //     title: "Weight Disputes",
  //     value: stats?.data?.weight_disputes || 0,
  //     bg: "from-orange-500 to-yellow-500",
  //   },
  //   {
  //     title: "WooCommerce",
  //     value: stats?.data?.woo_sales || stats?.data?.woocommerce_sales || "₹0",
  //     bg: "from-pink-500 to-rose-600",
  //   },
  //   {
  //     title: "Delivery Rate",
  //     value: `${
  //       stats?.data?.delivery_rate ||
  //       (stats?.data?.total_order
  //         ? Math.round(
  //             ((stats?.data?.total_delivered || 0) / stats?.data?.total_order) *
  //               100
  //           )
  //         : 0)
  //     }%`,
  //     bg: "from-violet-600 to-purple-700",
  //   },
  // ];


  const cards = [
    {
      title: "Total Orders",
      value: stats?.data?.total_order || orders.length,
      bg: "from-emerald-500 to-green-600",
    },
    {
      title: "NDR & RTO",
      value:
        (stats?.data?.total_ndr || 0) +
        (stats?.data?.total_rto || 0),
      bg: "from-teal-500 to-cyan-600",
    },
    {
      title: "COD Remittance",
      value:
        stats?.data?.cod_remittance || "₹0",
      bg: "from-amber-500 to-orange-500",
    },
    {
      title: "Weight Disputes",
      value:
        stats?.data?.weight_disputes || 0,
      bg: "from-orange-500 to-yellow-500",
    },
    {
      title: "Integration",
      value:
        stats?.data?.woo_sales ||
        stats?.data?.woocommerce_sales ||
        "₹0",
      bg: "from-pink-500 to-rose-600",
    },
    {
      title: "Delivery Rate",
      value: `${stats?.data?.delivery_rate ||
        (stats?.data?.total_order
          ? Math.round(
            ((stats?.data?.total_delivered ||
              0) /
              stats?.data?.total_order) *
            100
          )
          : 0)
        }%`,
      bg: "from-violet-600 to-purple-700",
    },
    {
      title: "Delivered",
      value:
        stats?.data?.total_delivered || 0,
      bg: "from-blue-500 to-indigo-600",
    },
    {
      title: "Prepaid Orders",
      value:
        stats?.data?.total_prepaid || 0,
      bg: "from-sky-500 to-cyan-600",
    },
  ];



  const formatCurrency = (value) =>
    new Intl.NumberFormat("en-IN", {
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(value || 0);

  const partners = Object.entries(stats?.data?.partnerPerformance || {})
    .map(([key, value]) => {
      const done = value?.delivred ?? 0;
      const inprocess = value?.in_process ?? 0;

      return {
        name: key,
        total: done + inprocess,
        done,
        inprocess
      };
    })
    .sort((a, b) => b.total - a.total)
    .slice(0, 5);

  return (
    // <div className="h-screen flex flex-col bg-[#f8fafc]">
    <div className="h-screen flex flex-col bg-[#f8fafc] dark:bg-gray-900 transition-colors">
      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className="w-64 border-r bg-white  dark:bg-gray-900">
            <Sidebar />
          </div>
        )}
        <div className="flex-1 overflow-auto p-6">
          <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">

            {cards.map((c, i) => (
              <div
                key={i}
                className={`rounded-3xl p-4 text-white
         bg-gradient-to-br ${c.bg} shadow-[0_18px_40px_rgba(0,0,0,0.12)] min-h-[120px] 
         border border-white/20 relative overflow-hidden hover:-translate-y-1 transition-all duration-300`}
              >

                <p className="text-xs opacity-90">
                  {c.title}
                </p>

                <p className="text-2xl font-bold mt-1 mb-2">
                  {c.value}
                </p>

                <div className="mt-1 text-[10px] space-y-1 opacity-95">

                  {i === 0 && (
                    <div className="flex items-center gap-2 flex-nowrap">

                      <div className="bg-white/15 rounded-xl px-2 py-1 text-center flex-1">
                        <div className="opacity-80 leading-none">
                          Delivered
                        </div>
                        <div className="font-semibold text-[10px] mt-1">
                          {stats?.data?.total_delivered || 0}
                        </div>
                      </div>

                      <div className="bg-white/15 rounded-xl px-2 py-1 text-center flex-1">
                        <div className="opacity-80 leading-none">
                          COD
                        </div>
                        <div className="font-semibold text-[10px] mt-1">
                          {stats?.data?.total_cod || 0}
                        </div>
                      </div>

                      <div className="bg-white/15 rounded-xl px-2 py-1 text-center flex-1">
                        <div className="opacity-80 leading-none">
                          Prepaid
                        </div>
                        <div className="font-semibold text-[10px] mt-1">
                          {stats?.data?.total_prepaid || 0}
                        </div>
                      </div>

                    </div>
                  )}

                  {i === 1 && (
                    <>
                      <div className="flex justify-between">
                        <span>NDR</span>
                        <span>{stats?.data?.total_ndr || 0}</span>
                      </div>

                      <div className="flex justify-between">
                        <span>RTO</span>
                        <span>{stats?.data?.total_rto || 0}</span>
                      </div>
                    </>
                  )}

                  {i === 2 && (
                    <>
                      <div className="flex justify-between">
                        <span>Last</span>
                        <span>{stats?.data?.last_remittance || "₹0"}</span>
                      </div>

                      <div className="flex justify-between">
                        <span>Next</span>
                        <span>{stats?.data?.next_remittance || "₹0"}</span>
                      </div>
                    </>
                  )}

                  {i === 3 && (
                    <>
                      <div className="flex justify-between">
                        <span>Open</span>
                        <span>{stats?.data?.weight_disputes || 0}</span>
                      </div>

                      <div className="flex justify-between">
                        <span>Resolved</span>
                        <span>{stats?.data?.resolved_disputes || 0}</span>
                      </div>
                    </>
                  )}

                  {i === 4 && (
                    <>
                      <div className="flex justify-between">
                        <span>Orders</span>
                        <span>{stats?.data?.woo_orders || 0}</span>
                      </div>

                      <div className="flex justify-between">
                        <span>Sales</span>
                        <span>{stats?.data?.woo_sales || "₹0"}</span>
                      </div>
                    </>
                  )}

                  {i === 5 && (
                    <>
                      <div className="flex justify-between">
                        <span>Delivered</span>
                        <span>{stats?.data?.total_delivered || 0}</span>
                      </div>

                      <div className="flex justify-between">
                        <span>Rate</span>
                        <span>{stats?.data?.delivery_rate || "91%"}</span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mt-6">
            <div className="xl:col-span-2 bg-white dark:bg-gray-800 rounded-2xl p-5 border">
              <div className="font-semibold text-slate-700 dark:text-gray-200 mb-4">
                Revenue Growth
              </div>

              <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={stats?.chartData?.monthlyData || []}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis tickFormatter={formatCurrency} />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="total_sales"
                      strokeWidth={3}
                      stroke="#2563eb"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-2xl border">
              <ImageOfferSlider />
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-2xl border mt-6 p-5">
            <h2 className="font-semibold text-slate-700 dark:text-gray-200 mb-4">
              Courier Partner Performance
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4 mb-6">
              {partners.map((p, i) => (
                <div key={i} className="border rounded-2xl p-4 bg-slate-50 dark:bg-gray-700">
                  <div className="font-semibold text-slate-700 dark:text-gray-200">
                    <div className="flex items-center justify-center">
                      {p.name?.toLowerCase() === "delhivery" && (
                        <img
                          src={
                            isDarkMode
                              ? "/assets/images/DelhiveryWhite.png"
                              : "/assets/images/Delhivery.png"
                          }
                          alt="Delhivery"
                          className="h-4 w-auto object-contain"
                        />
                      )}
                      {p.name?.toLowerCase() === "ecom" && (
                        <img
                          src={
                            isDarkMode
                              ? "/assets/images/logoecom.svg"
                              : "/assets/images/ecom-express-logo.png"
                          }
                          alt="Ecom Express"
                          className="h-10 w-auto object-contain"
                        />
                      )}
                      {p.name?.toLowerCase() === "ekart" && (
                        <img
                          src="/assets/images/ekart.png"
                          alt="Ekart"
                          className="h-10 w-auto object-contain"
                        />
                      )}
                      {p.name?.toLowerCase() === "xpressbees" && (
                        <img
                          src="/assets/images/xpressbess.png"
                          alt="xpressbess"
                          className="h-4 w-auto object-contain"
                        />
                      )}

                      {p.name?.toLowerCase() === "bluedart" && (
                        <div className="flex items-center">
                          <img
                            src="/assets/images/bluedart.png"
                            alt="bluedart"
                            className="h-[10px] w-auto object-contain"
                          />
                        </div>
                      )}
                      {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(
                        p.name?.toLowerCase()
                      ) && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                            {p.name || "Not Available"}
                          </span>
                        )}
                    </div>


                  </div>
                  <div className="text-xs text-slate-500 mt-2">
                    Total {p.total}
                  </div>
                  <div className="w-full h-2 bg-slate-200 dark:text-gray-200 rounded mt-2">
                    <div
                      className="h-2 bg-blue-500 rounded"
                      style={{ width: `${(p.done / p.total) * 100}%` }}
                    ></div>
                  </div>
                  <div className="text-xs text-green-600  mt-2">
                    Delivered {p.done}
                  </div>
                  <div className="text-xs text-blue-600">
                    In Process {p.inprocess}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white  dark:bg-gray-800 rounded-2xl shadow-sm  border mt-6 p-5">
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold text-slate-700 dark:text-gray-200">
                Pending Shipments
              </h2>
              <button
                onClick={() => navigate("/shipments/all")}
                className="text-blue-600"
              >
                View All
              </button>
            </div>
            {/* Mobile/Desktop Toggle */}
            <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700">
              <style>{`
    @keyframes fadeSlideIn {
      from { opacity: 0; transform: translateY(10px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .row-animate { animation: fadeSlideIn 0.35s ease both; }
    tr.row-animate:hover td { background-color: rgba(99,102,241,0.04); transition: background 0.2s; }
    @keyframes cardIn {
      from { opacity: 0; transform: translateY(12px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .card-animate { animation: cardIn 0.3s ease both; }
  `}</style>

              {/* ── MOBILE CARD VIEW ── */}
              <div className="block md:hidden p-3 space-y-3">
                {loadingOrders && (
                  <div className="py-8 text-center text-slate-400 flex items-center justify-center gap-2">
                    <svg className="animate-spin h-4 w-4 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                    </svg>
                    Loading orders...
                  </div>
                )}
                {!loadingOrders && orders.length === 0 && (
                  <div className="py-10 text-center text-slate-400">No pending shipments found</div>
                )}
                {!loadingOrders && orders.slice(0, 8).map((o, i) => {
                  const isPending = o.status?.toLowerCase().includes('pending');
                  const isFailed = o.status?.toLowerCase() === 'failed';
                  return (
                    <div
                      key={i}
                      className="card-animate bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 p-4"
                      style={{ animationDelay: `${i * 40}ms` }}
                    >
                      {/* Card Header */}
                      <div className="flex items-center justify-between mb-3">
                        <div>
                          <span className="font-bold text-sm text-indigo-600 dark:text-indigo-400">#{o.order_id || o.id}</span>
                          {o.user_id && <span className="ml-2 text-xs text-gray-400">UID: {o.user_id}</span>}
                        </div>
                        <span className={`px-2.5 py-1 text-xs font-medium rounded-full
              ${isFailed ? 'bg-red-100 text-red-700' :
                            isPending ? 'bg-yellow-100 text-yellow-700' :
                              'bg-emerald-100 text-emerald-700'}`}>
                          {o.status || "Pending"}
                        </span>
                      </div>

                      {/* Card Body Grid */}
                      <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-xs">
                        <div>
                          <div className="text-gray-400 mb-0.5">Recipient</div>
                          <div className="font-medium text-gray-800 dark:text-gray-200">{o.first_name || o.name || "—"} {o.last_name || ""}</div>
                          <div className="text-gray-400">{o.phone || ""}</div>
                        </div>
                        <div>
                          <div className="text-gray-400 mb-0.5">Payment</div>
                          <div className="font-semibold text-gray-800 dark:text-gray-200 capitalize">{o.payment_mode || "—"}</div>
                          {o.payment_mode === 'cod' && <div className="text-orange-500">COD: ₹{o.cod_amount}</div>}
                        </div>
                        <div>
                          <div className="text-gray-400 mb-0.5">Origin</div>
                          <div className="font-medium text-gray-800 dark:text-gray-200">{o.pickup_city || o.origin || "—"}</div>
                        </div>
                        <div>
                          <div className="text-gray-400 mb-0.5">Destination</div>
                          <div className="font-medium text-gray-800 dark:text-gray-200">{o.city || o.destination || "—"}</div>
                        </div>
                        <div>
                          <div className="text-gray-400 mb-0.5">Product</div>
                          <div className="text-gray-700 dark:text-gray-300 line-clamp-1">{o.products_desc || "—"}</div>
                          <div className="text-gray-400">Qty: {o.quantity} | {o.weight}g</div>
                        </div>
                        <div>
                          <div className="text-gray-400 mb-0.5">Date</div>
                          <div className="text-gray-700 dark:text-gray-300">{o.created_at ? o.created_at.split(" ")[0] : "—"}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* ── DESKTOP TABLE VIEW ── */}
              <div className="hidden md:block overflow-auto">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-slate-50 dark:bg-gray-800 border-b-2 border-indigo-200 dark:border-indigo-800">
                      {["Order", "User ID", "Recipient", "Product Details", "Payment", "Origin", "Destination", "Date", "Status"].map((heading) => (
                        <th key={heading} className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 border-r border-gray-200 dark:border-gray-700 last:border-r-0">
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                    {loadingOrders && (
                      <tr>
                        <td colSpan="9" className="py-8 text-center text-slate-400 dark:text-gray-400">
                          <div className="flex items-center justify-center gap-2">
                            <svg className="animate-spin h-4 w-4 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                            </svg>
                            Loading orders...
                          </div>
                        </td>
                      </tr>
                    )}
                    {!loadingOrders && orders.length === 0 && (
                      <tr><td colSpan="9" className="py-10 text-center text-slate-400 dark:text-gray-500">No pending shipments found</td></tr>
                    )}
                    {!loadingOrders && orders.slice(0, 8).map((o, i) => {
                      const isPending = o.status?.toLowerCase().includes('pending');
                      const isFailed = o.status?.toLowerCase() === 'failed';
                      return (
                        <tr key={i} className="row-animate group border-b border-gray-100 dark:border-gray-800 transition-colors duration-200 hover:bg-gray-50 dark:hover:bg-gray-800/50" style={{ animationDelay: `${i * 40}ms` }}>
                          <td className="py-4 px-3 border-r border-gray-100 dark:border-gray-800">
                            <span className="font-bold text-sm text-indigo-600 dark:text-indigo-400">{o.order_id || o.id}</span>
                          </td>
                          <td className="py-4 px-3 text-sm text-gray-600 dark:text-gray-400 border-r border-gray-100 dark:border-gray-800">{o.user_id || "—"}</td>
                          <td className="py-4 px-3 border-r border-gray-100 dark:border-gray-800">
                            <div className="font-medium text-sm text-gray-800 dark:text-gray-200">{o.first_name || o.name || "—"} {o.last_name || ""}</div>
                            <div className="text-xs text-gray-400 mt-0.5">{o.phone || ""}</div>
                            <div className="text-xs text-gray-400">{o.email || ""}</div>
                          </td>
                          <td className="py-4 px-3 border-r border-gray-100 dark:border-gray-800">
                            <div className="text-sm text-gray-800 dark:text-gray-200">{o.products_desc || "—"}</div>
                            <div className="text-xs text-gray-400 mt-0.5">Qty: {o.quantity} | Wt: {o.weight}g</div>
                            <div className="text-xs text-gray-400">{o.length}×{o.shipment_width}×{o.shipment_height} cm</div>
                          </td>
                          <td className="py-4 px-3 border-r border-gray-100 dark:border-gray-800">
                            <div className="font-semibold text-sm text-gray-800 dark:text-gray-200 capitalize">{o.payment_mode || "—"}</div>
                            {o.payment_mode === 'cod' && <div className="text-xs text-orange-500 font-medium">COD: ₹{o.cod_amount}</div>}
                          </td>
                          <td className="py-4 px-3 text-xs border-r border-gray-100 dark:border-gray-800">
                            <div className="font-medium text-gray-800 dark:text-gray-200">{o.pickup_city || o.origin || "—"}</div>
                          </td>
                          <td className="py-4 px-3 text-xs border-r border-gray-100 dark:border-gray-800">
                            <div className="font-medium text-gray-800 dark:text-gray-200">{o.city || o.destination || "—"}</div>
                          </td>
                          <td className="py-4 px-3 text-center text-xs text-gray-500 dark:text-gray-400 border-r border-gray-100 dark:border-gray-800">
                            {o.created_at ? o.created_at.split(" ")[0] : "—"}
                          </td>
                          <td className="py-4 px-3 text-center">
                            <span className={`px-3 py-1 text-xs font-medium rounded-full ${isFailed ? 'bg-red-100 text-red-700' : isPending ? 'bg-yellow-100 text-yellow-700' : 'bg-emerald-100 text-emerald-700'}`}>
                              {o.status || "Pending"}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
